export default [
    {
        path: "/login",
        name: "login",
        component: () => import("@/features/account/views/Login.vue"),
    },
    {
        path: "/change-password",
        name: "changePassword",
        component: () => import("@/features/account/views/ChangePassword.vue"),
    },
    {
        path: "/reset-password",
        name: "resetPassword",
        component: () => import("@/features/account/views/ResetPassword.vue"),
    },
    {
        path: "/request-reset-password",
        name: "requestResetPassword",
        component: () => import("@/features/account/views/RequestResetPassword.vue"),
    },
    {
        path: "/sign-up",
        name: "signUp",
        component: () => import("@/features/account/views/SignUp.vue"),
    },
    {
        path: "/two-factor-authentication",
        name: "twoFactorAuthentication",
        component: () => import("@/features/account/views/TwoFactorAuthentication.vue"),
    },
    {
        path: "/accept-invitation",
        name: "acceptInvitation",
        component: () => import("@/features/account/views/AcceptInvitation.vue")
    },
    {
        path: "/sso-callback",
        name: "ssoCallback",
        component: () => import("@/features/account/views/SSOCallback.vue"),
    },
    {
        path: "/sso-onboard",
        name: "shapingMindsID",
        component: () => import("@/features/account/views/SSOOnboard.vue"),
        // Part of signing in, so shown like the login page rather than inside the app.
        meta: { hideAppBar: true },
    },
    {
        // Reached from emailed invitation and password reset links.
        path: "/sso-onboard-token",
        name: "setUpShapingMindsID",
        component: () => import("@/features/account/views/SSOOnboardToken.vue"),
        meta: { hideAppBar: true },
    }
];
